import { render, staticRenderFns } from "./FilePondUploader.vue?vue&type=template&id=453c198d"
import script from "./FilePondUploader.vue?vue&type=script&lang=js"
export * from "./FilePondUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports